import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MailListItem from "../molecules/MailListItem";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { BigHeadline } from "../../../../components/TextParts";
import BaseApi from "../../../../functions/axios";
import NonIconButton from "../../../../components/NonIconButton";
import CloseRecruitment from "../organisms/CloseRecruitment";
import { recruitmentDetailContext } from "../../RecruitmentDetailPage";

export default function RecruitmentDetail() {
  const {
    mailSubject,
    setMailSubject,
    mailBody,
    setMailBody,
    setProjectId,
    setProjectStatus,
    setReason,
  } = useContext(recruitmentDetailContext);

  const location = useLocation();
  const navigate = useNavigate();
  const tmpProjectId = location.state?.projectId;

  useEffect(() => {
    if (!tmpProjectId) {
      alert("プロジェクトIDが指定されていません");
      navigate(-1);
      return;
    }

    setProjectId(tmpProjectId);

    const getMatchingList = async () => {
      try {
        const res = await BaseApi.get("recruitment");
        const resProjectList = res?.data?.data?.project_list || [];

        const targetProjectInfo = resProjectList.find(
          (projectInfo) => projectInfo.project_id === tmpProjectId
        );

        if (!targetProjectInfo) {
          alert("プロジェクトが存在しません");
          navigate(-1);
          return;
        }

        const project = targetProjectInfo.project || {};

        setMailBody({
          received: project.mail_received
            ? project.mail_received.slice(0, 10)
            : "メール受信日時が不明です",
          body: project.mail_body || "",
        });
        setMailSubject(project.mail_subject || "");
        setProjectStatus(project.status);
        setReason(project.reason);
      } catch (error) {
        console.error("getMatchingList error:", error);
        alert("データの取得に失敗しました");
      }
    };

    getMatchingList();
  }, [tmpProjectId, setProjectId, setMailBody, setMailSubject, setProjectStatus, setReason, navigate]);

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" } }}>
        <Box sx={{ flexGrow: 1 }}>
          <BigHeadline text={mailSubject} />
        </Box>
        <Box
          sx={{
            width: "160px",
            flexShrink: 0,
            pb: "20px",
            pt: { xs: "0px", sm: "50px" },
            mx: "auto",
          }}
        >
          <NonIconButton
            title="案件を複製"
            clickEvent={() => {
              navigate("/projectRegister", {
                state: {
                  mailSubject,
                  mailBody: mailBody.body,
                },
              });
            }}
          />
        </Box>
      </Box>
      <Paper
        sx={{
          width: "100%",
          borderRadius: "5px",
          boxShadow: "none",
          minHeight: "300px",
        }}
      >
        <Box sx={{ p: "20px" }}>
          <MailListItem name={mailBody.received} text={mailBody.body} />
        </Box>
      </Paper>
      <CloseRecruitment />
    </Box>
  );
}